export enum StatusKeyEnum {
  // Outreach ==================================================================
  NEW = 'new',
  ATTEMPTED = 'attempted',
  INTERACTED = 'interacted',
  // Support ===================================================================
  NEWLY_ENGAGED = 'newly-engaged',
  QUEUED = 'queued',
  RE_ENGAGED = 're-engaged',
  // Skill Building ============================================================
  SKILL_BUILDING = 'skill-building',
  // Independence ===============================================================
  MISCONDUCT = 'misconduct',
  REFUSED_SERVICES = 'refused-services',
  OFF_PLAN = 'off-plan',
  COMPLETED = 'completed',
  TIMED_OUT = 'timed-out',
  DECEASED = 'deceased',
  UNABLE_TO_NEWLY_ENGAGE = 'unable-to-newly-engage',
  UNABLE_TO_RE_ENGAGE = 'unable-to-re-engage',
  OUT_OF_SCOPE = 'out-of-scope',
  // DEPRECATED ================================================================
  // Out-Of-Program ============================================================
  GRADUATED = 'graduated',
  NO_CONTACT = 'no-contact',
  DISCHARGED = 'discharged',
  PAUSED = 'paused',
  INELIGIBLE = 'ineligible',
  UNEQUIPPED = 'unequipped',
}

export type StatusKey = `${StatusKeyEnum}`;

/**
 * Whether status changes from the current status are restricted to users with
 * `CAN_REQUEST_ADMIN_LEVEL_STATUSES`.
 *
 * @param currentStatusKey - The member's current status key.
 * @returns True when the member is out of scope.
 */
export function isOutOfScopeStatusChangeRestricted(
  currentStatusKey: string | null | undefined
): boolean {
  return currentStatusKey === StatusKeyEnum.OUT_OF_SCOPE;
}

/**
 * Statuses a manager can dismiss after the fact: dismissed when the system
 * raised them, denied through the audit dialog when a guide requested them.
 * The dismiss endpoint enforces this same list.
 */
export const DISMISSABLE_MEMBER_STATUS_KEYS: readonly string[] = [
  StatusKeyEnum.UNABLE_TO_NEWLY_ENGAGE,
  StatusKeyEnum.UNABLE_TO_RE_ENGAGE,
];
